import React from "react";

import EmptyModels from "@/assets/images/EmptyModels.svg?react";
import EmptyTrash from "@/assets/images/EmptyTrash.svg?react";
import EmptyTokens from "@/assets/images/EmptyTokens.svg?react";
import EmptyConnections from "@/assets/images/EmptyConnections.svg?react";

const illustrations = {
  models: EmptyModels,
  trash: EmptyTrash,
  tokens: EmptyTokens,
  connections: EmptyConnections,
} as const;

export type EmptyStateVariant = keyof typeof illustrations;

interface EmptyStateProps {
  variant?: EmptyStateVariant;
  title: string;
  subtitle?: string;
  secondary?: boolean;
  /// Optional call-to-action rendered under the subtitle (e.g. a primary
  /// "New model" button).
  action?: React.ReactNode;
  /// Inside a small panel rather than a page: no page-height top space, and the
  /// lines held narrow enough to read as a sentence.
  compact?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  variant,
  title,
  subtitle,
  secondary = false,
  action,
  compact = false,
}) => {
  const Illustration = variant ? illustrations[variant] : null;

  return (
    <div
      className={`flex flex-col items-center select-none gap-1 ${
        compact ? "px-6 py-3" : "pt-[10%] h-full"
      }`}
    >
      {Illustration && <Illustration className="w-96 h-52 mb-4" />}
      <p
        className={`text-center text-balance ${secondary ? "text-fg-muted-regular" : "text-fg-medium"}`}
      >
        {title}
      </p>
      {subtitle && (
        <p
          className={`text-fg-muted-regular text-center text-balance ${compact ? "max-w-[40ch]" : ""}`}
        >
          {subtitle}
        </p>
      )}
      {action && <div className="mt-4 select-auto">{action}</div>}
    </div>
  );
};
